<template>
  <div>
    <date-picker
      v-model:value="defaultValue"
      valueType="format"
      :clearable="false"
      :type="type"
      :value-type="type === 'datetime' ? 'timestamp' : 'format'"
      :format="format"
      :message="message"
      @change="(value) => $emit('change', { target: { value, name } })"
      @close="(value) => $emit('closePanel')"
    >
    </date-picker>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

@Options({
  name: 'Calendar',
  props: ['name', 'message', 'value', 'type', 'format'],
  components: {
    DatePicker
  },
  data() {
    return {
      defaultValue: null
    };
  },
  mounted() {
    this.defaultValue = this.value;
  }
})
export default class CalendarComponent extends Vue {}
</script>

<style lang="scss">
.mx-datepicker {
  width: 175px;
  height: 42px;
  .mx-input-wrapper {
    height: 100%;
    .mx-input {
      height: 42px;
      border-radius: 8px;
      color: $borderedInactive;
      border: 1px solid $border;
      box-shadow: none;
      &:focus {
        border-color: $main-green;
      }
      &:hover {
        border-color: $main-green;
      }
    }
  }
}

.mx-datepicker-content {
  .mx-calendar {
    &.mx-calendar-panel-date {
      .mx-calendar-header {
        .mx-icon-double-left {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-icon-left {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-calendar-header-label {
          button {
            color: $mid-grey;
            &:hover {
              border-color: $main-green;
              color: $main-green;
            }
          }
        }
        .mx-icon-double-right {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-icon-right {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
      }
      .mx-calendar-content {
        .mx-table {
          &.mx-table-date {
            thead {
              th {
                color: $mid-grey;
              }
            }
            tbody {
              .mx-date-row {
                .cell {
                  div {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                  }
                  &.not-current-month {
                    opacity: 0;
                    cursor: default;
                  }
                  &.active {
                    background-color: $white;
                    border-radius: 15px;
                    div {
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      background-color: $main-green;
                      width: 30px;
                      height: 30px;
                      color: $white;
                      border-radius: 15px;
                    }
                  }
                  &:hover {
                    background-color: $white;
                  }
                  &:hover div {
                    background-color: $main-green;
                    border-radius: 15px;
                    color: $white;
                  }
                }
              }
            }
          }
        }
      }
    }
    &.mx-calendar-panel-month {
      .mx-calendar-header {
        .mx-icon-double-left {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-icon-double-right {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-calendar-header-label {
          button {
            color: $mid-grey;
            &:hover {
              border-color: $main-green;
              color: $main-green;
            }
          }
        }
      }
      .mx-calendar-content {
        .mx-table {
          &.mx-table-month {
            .cell {
              div {
                display: inline-flex;
                width: 60px;
                height: 30px;
                align-items: center;
                justify-content: center;
                font-family: 'Ubuntu-Regular';
                font-size: $fourteenSize;
                line-height: 16px;
                background-color: $light-grey;
                border-radius: 8px;
              }
              &.active {
                background-color: $white;
                div {
                  background-color: $main-green;
                  color: $white;
                  border-radius: 8px;
                }
              }
              &:hover {
                background-color: $white;
              }
              &:hover div {
                background-color: $main-green;
                border-radius: 8px;
                color: $white;
              }
            }
          }
        }
      }
    }
    &.mx-calendar-panel-year {
      .mx-calendar-header {
        .mx-icon-double-left {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-icon-double-right {
          color: $mid-grey;
          &:hover {
            color: $main-green;
          }
        }
        .mx-calendar-header-label {
          span {
            color: $mid-grey;
          }
          &:hover span {
            border-color: $main-green;
            color: $main-green;
          }
        }
      }
      .mx-calendar-content {
        .mx-table {
          &.mx-table-year {
            .cell {
              div {
                display: inline-flex;
                width: 100px;
                height: 30px;
                align-items: center;
                justify-content: center;
                font-family: 'Ubuntu-Regular';
                font-size: $fourteenSize;
                line-height: 16px;
                background-color: $light-grey;
                border-radius: 8px;
              }
              &.active {
                background-color: $white;
                div {
                  background-color: $main-green;
                  color: $white;
                  border-radius: 8px;
                }
              }
              &:hover {
                background-color: $white;
              }
              &:hover div {
                background-color: $main-green;
                border-radius: 8px;
                color: $white;
              }
            }
          }
        }
      }
    }
  }
  .mx-time {
    .mx-time-header {
      .mx-btn {
        color: $mid-grey;
        &:hover {
          border-color: $main-green;
          color: $main-green;
        }
      }
    }
    .mx-time-content {
      .mx-time-columns {
        .mx-scrollbar {
          &.mx-time-column {
            .mx-scrollbar-wrap {
              .mx-time-list {
                .mx-time-item {
                  font-family: 'Ubuntu-Regular';
                  font-size: $fourteenSize;
                  color: $mid-grey;
                  &.active {
                    color: $main-green;
                  }
                  &:hover {
                    color: $white;
                    background-color: $main-green;
                    border-radius: 8px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
